import React from 'react';
import { Container } from 'reactstrap';

// Import Images
import image from "../../../assets/images/pages/search.png";
import UiContent from '../../../Components/Common/UiContent';

const Search404 = () => {
    return (
        <React.Fragment>
            <UiContent />
            <div className="page-content m-0 d-flex flex-column align-items-center text-center">
                <Container fluid>
                    <div>
                        <img src={image} alt="Página no encontrada" style={{ maxWidth: '40%', height: 'auto' }} />
                    </div>
                    <div className="mt-3">
                        <h3>¡Ups! Falta seleccionar un establecimiento</h3>
                        <p className="text-muted mb-4">
                            Para continuar, elige un establecimiento en el menú de navegación.
                        </p>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Search404;
